<template>
  <div class="solution-page">
    <!-- 头部介绍 -->
    <div 
      class="solution-header"
      :style="{
        backgroundImage: pageData.cover ? `url(${pageData.cover})` : '',
      }"
    >
      <div class="container">
        <h1>{{ pageData.name || '硬件维保' }}</h1>
        <p class="description">{{ pageData.desc }}</p>
      </div>
    </div>

    <!-- 服务介绍 -->
    <section class="service-intro">
      <div class="container">
        <div class="intro-grid">
          <div class="intro-content">
            <h2 class="section-title animate-title">专业的第三方维保服务</h2>
            <p>湖南美音通过多年的行业积累与项目经验，以提高业务系统可用性为目标，凭借硬件、软件和业务系统运维服务为基本支持，辅以监控服务与流程管理，为客户提供硬件的第三方维保服务，并可根据客户需求，提供可选的业务应急保障服务，保障业务系统的长期稳定运行。</p>
            <div class="service-items">
              <div class="service-item">
                <el-icon><Monitor /></el-icon>
                <span>UPS设备</span>
              </div>
              <div class="service-item">
                <el-icon><SetUp /></el-icon>
                <span>精密空调</span>
              </div>
              <div class="service-item">
                <el-icon><Cpu /></el-icon>
                <span>服务器/小型机</span>
              </div>
              <div class="service-item">
                <el-icon><Connection /></el-icon>
                <span>网络设备</span>
              </div>
              <div class="service-item">
                <el-icon><DataLine /></el-icon>
                <span>存储/备份设备</span>
              </div>
              <div class="service-item">
                <el-icon><Lock /></el-icon>
                <span>信息安全设备</span>
              </div>
            </div>
          </div>
          <div class="intro-image">
            <img src="@/assets/images/DSC_2467.jpg" alt="硬件维保服务">
          </div>
        </div>
      </div>
    </section>

    <!-- 服务价值 -->
    <section class="service-value">
      <div class="container">
        <h2 class="section-title animate-title">服务价值</h2>
        <div class="value-grid">
          <div class="value-item">
            <el-icon><Aim /></el-icon>
            <h3>确保业务高可用性</h3>
          </div>
          <div class="value-item">
            <el-icon><Medal /></el-icon>
            <h3>服务质量高保障</h3>
          </div>
          <div class="value-item">
            <el-icon><Management /></el-icon>
            <h3>面向业务</h3>
          </div>
          <div class="value-item">
            <el-icon><User /></el-icon>
            <h3>专业团队支持</h3>
          </div>
          <div class="value-item">
            <el-icon><Money /></el-icon>
            <h3>降低运营成本</h3>
          </div>
          <div class="value-item">
            <el-icon><Plus /></el-icon>
            <h3>增值服务</h3>
          </div>
          <div class="value-item">
            <el-icon><Warning /></el-icon>
            <h3>降低风险</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务优势 -->
    <section class="service-advantages">
      <div class="container">
        <h2 class="section-title animate-title">服务优势</h2>
        <div class="advantages-grid">
          <div class="advantage-item">
            <div class="icon">
              <el-icon><Box /></el-icon>
            </div>
            <div class="content">
              <h3>备品备件齐全</h3>
              <p>完善的备件库存管理，确保维修效率</p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon">
              <el-icon><Location /></el-icon>
            </div>
            <div class="content">
              <h3>本地化服务团队</h3>
              <p>快速响应，及时解决问题</p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon">
              <el-icon><SetUp /></el-icon>
            </div>
            <div class="content">
              <h3>定制服务</h3>
              <p>根据客户需求提供个性化服务方案</p>
            </div>
          </div>
          <div class="advantage-item">
            <div class="icon">
              <el-icon><Service /></el-icon>
            </div>
            <div class="content">
              <h3>一站式服务</h3>
              <p>提供全面的硬件维保解决方案</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { columnGet2 } from "@/api/court";
import { 
  Monitor, 
  SetUp, 
  Server, 
  DataLine, 
  Lock,
  Aim,
  Medal,
  Management,
  User,
  Money,
  Plus,
  Box,
  Location,
  Service,
  Connection,
  Cpu,
  Warning
} from '@element-plus/icons-vue'

const pageData = ref({})

// 获取页面数据
const getPageData = async () => {
  try {
    const response = await columnGet2({
      page: 1,
      limit: 10000,
      is_enable: true,
      parent: 9,
    });
    if (response.data.code === 2000) {
      // 根据当前页面名称匹配对应的数据
      const data = response.data.data.data.find(item => {
        // 根据路径匹配对应的数据
        return item.name.includes('硬件维保') || item.name.toLowerCase().includes('hardware')
      })
      if (data) {
        pageData.value = data
      }
    }
  } catch (error) {
    console.error('获取页面数据失败:', error)
  }
}

onMounted(() => {
  // 确保页面从顶部开始显示
  console.log('🔧 硬件维保页面组件挂载，确保滚动到顶部')
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  window.scrollTo(0, 0)

  getPageData()
})
</script>

<style lang="scss" scoped>
// 定义主题色变量
$primary-color: #2b5dff;
$primary-light: rgba(43, 93, 255, 0.1);
$border-color: #e2e8f0;

.solution-page {
  padding-top: 30px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  section {
    padding: 80px 0;
  }

  // 头部样式
  .solution-header {
    background-size: cover;
    color: #fff;
    padding: 60px 0 40px;
    text-align: center;
    position: relative;
    overflow: hidden;
    margin-bottom: 60px;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background:rgba(0, 0, 0, 0.5);
      opacity: 0.5;
    }

    .container {
      position: relative;
      z-index: 1;
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
    }

    h1 {
      font-size: 36px;
      margin-bottom: 10px;
      position: relative;
      display: inline-block;
      opacity: 0;
      transform: translateY(20px);
      animation: fadeInUp 0.8s ease forwards;
    }

    .description {
      font-size: 18px;
      opacity: 0;
      transform: translateY(20px);
      animation: fadeInUp 0.8s ease forwards 0.2s;
      margin: 20px auto 0;
      max-width: 800px;
      line-height: 1.8;
    }
  }

  // 服务介绍样式
  .service-intro {
    .intro-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 60px;
      align-items: center;

      .intro-content {
        h2 {
          font-size: 32px;
          margin-bottom: 30px;
          color: #333;
        }

        p {
          color: #666;
          line-height: 1.8;
          margin-bottom: 40px;
        }

        .service-items {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 20px;

          .service-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 15px;
            background: #f8f9fc;
            border-radius: 8px;
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-3px);
              background: #fff;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }

            .el-icon {
              font-size: 24px;
              color: #2b5dff;
            }
          }
        }
      }

      .intro-image {
        img {
          width: 100%;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

  // 服务价值样式
  .service-value {
    background: #f8f9fc;

    h2 {
      text-align: center;
      font-size: 32px;
      margin-bottom: 50px;
      color: #333;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -15px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 3px;
        background: #2b5dff;
        border-radius: 2px;
      }
    }

    .value-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      max-width: 1200px;
      margin: 0 auto;

      .value-item {
        text-align: center;
        padding: 30px 20px;
        background: #fff;
        border-radius: 12px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

          .el-icon {
            color: #fff;
            background: #2b5dff;
            transform: scale(1.1);
          }
        }

        .el-icon {
          font-size: 32px;
          color: #2b5dff;
          background: rgba(43, 93, 255, 0.1);
          width: 70px;
          height: 70px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
          transition: all 0.3s ease;
        }

        h3 {
          font-size: 18px;
          color: #333;
          margin: 0;
        }
      }
    }
  }

  // 服务优势样式
  .service-advantages {
    h2 {
      text-align: center;
      font-size: 32px;
      margin-bottom: 50px;
      color: #333;
      position: relative;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -15px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 3px;
        background: #2b5dff;
        border-radius: 2px;
      }
    }

    .advantages-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
      
      .advantage-item {
        background: #fff;
        padding: 30px;
        border-radius: 12px;
        display: flex;
        align-items: flex-start;
        gap: 20px;
        transition: all 0.3s ease;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
          
          .icon {
            background: #2b5dff;
            
            .el-icon {
              color: #fff;
              transform: scale(1.1);
            }
          }
        }

        .icon {
          flex-shrink: 0;
          width: 60px;
          height: 60px;
          background: rgba(43, 93, 255, 0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;

          .el-icon {
            font-size: 28px;
            color: #2b5dff;
            transition: all 0.3s ease;
          }
        }

        .content {
          flex: 1;
          
          h3 {
            font-size: 20px;
            color: #333;
            margin-bottom: 10px;
          }

          p {
            color: #666;
            line-height: 1.6;
            margin: 0;
            font-size: 15px;
          }
        }
      }
    }
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media screen and (max-width: 768px) {
  .solution-header {
    padding: 100px 0 40px;

    h1 {
      font-size: 28px;
    }

    .description {
      font-size: 14px;
    }
  }
}

@media (max-width: 992px) {
  .solution-page {
    .intro-grid,
    .advantages-grid {
      grid-template-columns: 1fr !important;
    }
    
    .value-grid {
      grid-template-columns: repeat(3, 1fr) !important;
    }
  }
}

@media (max-width: 768px) {
  .solution-page {
    section {
      padding: 60px 0;
    }

    .value-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }

    .advantage-item {
      padding: 20px !important;
      
      .icon {
        width: 50px !important;
        height: 50px !important;
        
        .el-icon {
          font-size: 24px !important;
        }
      }
      
      .content {
        h3 {
          font-size: 18px !important;
        }
        
        p {
          font-size: 14px !important;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .solution-page {
    .value-grid {
      grid-template-columns: 1fr !important;
    }
  }
}
</style> 